import { useParams } from 'react-router-dom';
import { OurAgencyPresentation, OneDayPresentation, CombinedPresentation, TwoDayPresentation } from './';
import '../../styles/tours/WrapTour.css'

export const WrapPresentation = () => {
  const { lang } = useParams();
  const { id,  } = 123;
  return (
    <div className="wrap-presentacion-item">
        <div className="accordion" id={ `accordion-${id}` }>
            <div className="card">
                <div className="card-header" id="headingOne">
                <h2 className="mb-0">
                    <button className="btn btn-link btn-block text-center collapsed border border-danger rounded-pill" type="button" data-toggle="collapse" data-target={`#collapseOne-${id}`} aria-expanded="true" aria-controls={`collapseOne-${id}`}>
                    { lang === 'en' ? 'Our Agency' : 'Nuestra Agencia' }
                    </button>
                </h2>
                </div>

                <div id={`collapseOne-${id}`} className="collapse show" aria-labelledby="headingOne" data-parent={ `#accordion-${id}` }>
                <div className="card-body">
                    <OurAgencyPresentation />
                </div>
                </div>
            </div>
            <div className="card">
                <div className="card-header" id="headingTwo">
                <h2 className="mb-0">
                    <button className="btn btn-link btn-block text-center collapsed border border-warning rounded-pill" type="button" data-toggle="collapse" data-target={`#collapseTwo-${id}`} aria-expanded="false" aria-controls={`collapseTwo-${id}`}>
                    { lang === 'en' ? 'Most Visited Tours' : 'Tours más Visitados' }
                    </button>
                </h2>
                </div>
                <div id={`collapseTwo-${id}`} className="collapse" aria-labelledby="headingTwo" data-parent={ `#accordion-${id}` }>
                <div className="card-body">
                    <OneDayPresentation />
                </div>
                </div>
            </div>
            <div className="card">
                <div className="card-header" id="headingThree">
                <h2 className="mb-0">
                    <button className="btn btn-link btn-block text-center collapsed border border-success rounded-pill" type="button" data-toggle="collapse" data-target={`#collapseThree-${id}`} aria-expanded="false" aria-controls={`collapseThree-${id}`}>
                        { lang === 'en' ? 'Combined Tours' : 'Tours Combinados' }
                    </button>
                </h2>
                </div>
                <div id={`collapseThree-${id}`} className="collapse" aria-labelledby="headingThree" data-parent={ `#accordion-${id}` }>
                <div className="card-body">
                    <CombinedPresentation />
                </div>
                </div>
            </div>
            <div className="card">
                <div className="card-header" id="headingFour">
                <h2 className="mb-0">
                    <button className="btn btn-link btn-block text-center collapsed border border-success rounded-pill" type="button" data-toggle="collapse" data-target={`#collapseFour-${id}`} aria-expanded="false" aria-controls={`collapseFour-${id}`}>
                        { lang === 'en' ? '2 days 1 night Tours' : 'Tours de 2 días & 1 noche' }
                    </button>
                </h2>
                </div>
                <div id={`collapseFour-${id}`} className="collapse" aria-labelledby="headingFour" data-parent={ `#accordion-${id}` }>
                <div className="card-body">
                    <TwoDayPresentation />
                </div>
                </div>
            </div>
            <div className="card">
                <div className="card-header" id="headingFive">
                <h2 className="mb-0">
                    <button className="btn btn-link btn-block text-center collapsed border border-success rounded-pill" type="button" data-toggle="collapse" data-target={`#collapseFive-${id}`} aria-expanded="false" aria-controls={`collapseFive-${id}`}>
                        { lang === 'en' ? 'Traveling Guatemala' : 'Giras de Turismo' }
                    </button>
                </h2>
                </div>
                <div id={`collapseFive-${id}`} className="collapse" aria-labelledby="headingFive" data-parent={ `#accordion-${id}` }>
                <div className="card-body">
                    info
                </div>
                </div>
            </div>
            <div className="card">
                <div className="card-header" id="headingSix">
                <h2 className="mb-0">
                    <button className="btn btn-link btn-block text-center collapsed border border-success rounded-pill" type="button" data-toggle="collapse" data-target={`#collapseSix-${id}`} aria-expanded="false" aria-controls={`collapseSix-${id}`}>
                        { lang === 'en' ? 'Contact' : 'Contacto' }
                    </button>
                </h2>
                </div>
                <div id={`collapseSix-${id}`} className="collapse" aria-labelledby="headingSix" data-parent={ `#accordion-${id}` }>
                <div className="card-body">
                    <p>Para una atención más personalizada, siempre puede ponerse en contacto con nosotros a través de los siguientes medios.</p>
                </div>
                </div>
            </div>
        </div>
    </div>
  )
}
